<template>
  <el-form
    :model="usuarioAutenticacao"
    class="login-form"
    @submit.prevent="submit"
  >
    <el-form-item>
      <template #label> CPF <span>(passport)</span> </template>
      <el-input
        class="input-login"
        v-model="usuarioAutenticacao.login"
        placeholder="Digite seu CPF (passport)"
        v-mask="maskCPF"
      />
    </el-form-item>
    <el-form-item>
      <template #label> Senha <span>(password)</span> </template>
      <el-input
        class="input-login"
        v-model="usuarioAutenticacao.password"
        type="password"
        placeholder="Digite sua senha (password)"
      />
    </el-form-item>
    <el-form-item style="margin-top: 25px">
      <el-button
        class="big-button green-filled"
        type="primary"
        @click="submit"
        block
        >Login</el-button
      >
    </el-form-item>
    <el-form-item>
      <el-link
        class="el-button big-button green-border"
        :href="contextPath + 'api/autenticacao/nova-conta'"
        >Cadastre-se</el-link
      >
    </el-form-item>
    <el-row justify="space-between" class="form-links">
      <el-link
        class="green-link"
        :href="contextPath + 'api/autenticacao/esqueci-minha-senha'"
        >Esqueci a senha</el-link
      >
    </el-row>
    <el-row justify="space-between" class="form-links">
      <el-link
        class="green-link"
        :href="contextPath + 'api/autenticacao/foreign-registration'"
        >Foreign Registration</el-link
      >
    </el-row>
  </el-form>
</template>

<script>
import LoginService from "@/services/LoginService.js";
import { mask } from "vue-the-mask";

export default {
  name: "LoginForm",
  directives: {
    mask
  },
  computed: {
    maskCPF() {
      const raw = this.usuarioAutenticacao.login.replace(/\W/g, "");
      const isNumeric = /^\d+$/.test(raw);

      if (isNumeric && raw.length > 10) {
        return "###.###.###-##";
      }
      return "XXXXXXXXXXX";
    }
  },
  data() {
    return {
      usuarioAutenticacao: {
        login: "",
        password: ""
      },
      contextPath: process.env.VUE_APP_CONTEXT_PATH || "/"
    };
  },
  methods: {
    submit() {
      if (this.usuarioAutenticacao.login && this.usuarioAutenticacao.password) {
        LoginService.logar(this.usuarioAutenticacao)
          .then(response => {
            if (response.status === 200) {
              localStorage.setItem("nomeUser", response.data.nome);
              localStorage.setItem("login", response.data.login);
              localStorage.setItem(
                "sessionKeyEntradaUnica",
                response.data.sessionKeyEntradaUnica
              );
              localStorage.setItem(
                "pessoa",
                JSON.stringify(response.data.pessoa)
              );
              this.$router.push("/");
            }
          })
          .catch(error => {
            const h = this.$createElement;

            this.$notify({
              title: "Erro de Login",
              message: h(
                "i",
                { style: "color: #295661" },
                "CPF, passaporte ou senha inválidos. Por favor, tente novamente."
              )
            });
          });
      }
    }
  }
};
</script>

<style>
.input-login input.el-input__inner {
  border-radius: 8px !important;
  border: 1px solid #bebebe;
  background: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form-item__label {
  color: #383838;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.el-button.big-button,
.el-link.big-button {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 0px 15px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 20px;
  font-weight: 700;
}

.el-button.green-border,
.el-link.green-border {
  border: 2px solid #00c254;
  color: #00c254 !important;
  background-color: transparent;
}
.el-link.is-underline:hover:after {
  border-bottom: none !important;
}

.el-link.green-link {
  color: #00c254 !important;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 700;
}
</style>

<style scoped>
.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.form-links {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.el-form-item__label span {
  color: #9f9f9f;
}
</style>
